import React, { useState, useEffect } from "react";
import _ from 'lodash';
import './style.scss';
import { Layout, Space, Button, Table, Popconfirm, PageHeader, Modal, Input, Checkbox, message } from 'antd';
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EmployeeService from "../../../services/EmployeeService";
// import { useSelector } from 'react-redux';
import Delete from "../../../assets/images/delete_icon.svg";
import { FeatureList } from "./constants";
import { CloseOutlined, PlusCircleFilled } from "@ant-design/icons";


const { Content } = Layout;
const newCustom = {
    "name": "",
    "has_dashboard": true,
    "has_orders": true,
    "has_kds_station": true,
    "has_expo": true,
    "has_menu": true,
    "has_pos": true,
    "has_delivery": true,
    "has_business": true,
    "has_employees": true,
    "restaurant_id": 1
  }


const EmployeType = (props) => {
    const [addNew, setAddNew] = useState(false);
    const [newType, setNewType] = useState({...newCustom});
    const [loading, setLoading] = useState(true);
    const [dataList, setDataList] = useState([]);

    // const adminRestaurant = useSelector((state) => state.admin)
    const getCustomizationList = async() => {
        const res = await EmployeeService.getEmployeType(props.adminRestaurant);
        setDataList(res);
        setLoading(false);
    }
    useEffect(()=>{
        getCustomizationList();
    },[]);
    const updateRecord = (data) => {
        setNewType(data);
        setAddNew(true);
    };
    const updateApi = (updateData) => {
        const currentData = { ...updateData };
        delete currentData.id;
        delete currentData.created_at;
        delete currentData.updated_at;
        EmployeeService.updateEmployeType(currentData, updateData.id).then((res)=>{
            if(res){
                message.success("Successfully updated");
                getCustomizationList();
                setAddNew(false);
                setNewType({...newCustom});
            }
        });
    }
    const onRemove = (data, field) => {
        const currentValues = {...data};
        currentValues[field] = false;
        updateApi(currentValues);
    };
    const columns = [
        {
            title: 'Type Name',
            dataIndex: 'name',
            key: 'name',
            width: '25%' 
        },
        {
            title: 'Assign Features',
            dataIndex: 'applicable',
            key: 'applicable',
            width: '60%', 
            render: (_, record) => {
                return <div className="applicable_list">
                        {FeatureList?.map((item) => {
                            if(record[item.value]) {
                                return <div className="chip-view">
                                    <div>{item?.label}</div> <div className="close_btn" onClick={()=>{onRemove(record, item.value)}}><CloseOutlined /></div>
                                </div>
                            }
                        })}
                        <div><PlusCircleFilled className="update_typebtn" onClick={()=>{ updateRecord(record)}}/></div>
                </div>
            }
        },
        {
            title: 'Action',
            width: '15%', 
            render: (_, record) => {
                return <div
                    style={{
                        display: "flex", width: '150px'}}>
                        <>
                            <Popconfirm title="Sure to delete?" onConfirm={(e) => {
                                e.stopPropagation()
                                deleteCode(record.id)
                            }
                            }>
                            <img src={Delete} alt="" className="update_action" />
                            </Popconfirm>
                        </>
                </div>
            }
        }
    ];

    const deleteCode =  (id) => {
         EmployeeService.deleteEmployeType(id).then((res)=>{
            if(res){
                getCustomizationList();
                message.success("Successfully deleted");
            }
         });
        getCustomizationList();
    };
    const onNameChange = (e) => {
        const currentValues = {...newType};
        currentValues[e.target.name] = e.target.value.trimStart();
        currentValues.restaurant_id = props.adminRestaurant;
        setNewType(currentValues);
    };
    const onFeatChange = (e, field) => {
        const currentValues = {...newType};
        currentValues[field] = e.target.checked;
        setNewType(currentValues);
    };
    const saveEmployeType = () => {
        if(newType.id){
            updateApi(newType);
        } else {
            EmployeeService.addEmployeType(newType).then((res)=>{
                if(res){
                    message.success("Successfully saved");
                    getCustomizationList();
                    setAddNew(false);
                    setNewType({...newCustom});
                }
            }).catch((res)=>{
                message.error("Something went wrong");
                setAddNew(false);
                setNewType({...newCustom});
            })
        }
    }

    return (
        <Layout className="u-page-layout">
            <Content className="page-padding" >
                <Space direction="vertical" style={{ width: "100%" }}>
                    <PageHeader
                        title="Employee Types"
                        className="page-header"
                        extra={[
                            <Button type="primary" 
                            onClick={() => { setAddNew(true); setNewType(_.cloneDeep(newCustom)); }}>Add Employee Type</Button>,
                        ]} />
                        <div className="table_section">
                            <Table columns={columns} loading={loading} bordered dataSource={dataList || []} className="customise-table overflow-auto" />
                        </div>
                        <Modal visible={addNew} footer={null} onCancel={()=>setAddNew(false)} className="member_deleteconfirm">
                            <div className="feat_wrap">
                                <h3 className="title">{newType.id ? "Update Employee Type" : "Add Employee Type"}</h3>
                                <div className="sub_title">Type Name</div>
                                <div><Input placeholder="Enter Type Name" value={newType.name} name="name" onChange={(e)=> onNameChange(e)}/></div>
                                <div className="sub_title">Features</div>
                                <div className="feat_list">
                                    {
                                        FeatureList.map((item)=>{
                                           return  <div className="feat_item">
                                                <Checkbox checked={newType[item.value]} onChange={(e)=>{onFeatChange(e, item.value)}}>{item.label}</Checkbox>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className="typesave_btn"><Button type="primary" onClick={saveEmployeType} disabled={!newType.name}>Save</Button></div>
                            </div>
                        </Modal>
                </Space>
            </Content>
            <R2Footer />
        </Layout>
    )
}

const mapStateToProps = state => {
    return {
        adminRestaurant: state.admin,
    };
};
export default withRouter(connect(
    mapStateToProps
)(EmployeType));
